import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRescheduleTypeList = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `productivity-host/reschedule/list?${queries}` });

  return data?.data;
};

export default getRescheduleTypeList;
